exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/businessRules/megamillions-rules/megamillions-rules.component.scss
// module id = ../../../../../src/app/components/businessRules/megamillions-rules/megamillions-rules.component.scss
// module chunks = main